<template>
    <div class="sendform-modal">
        <div class="modal animated fadeIn">
            <button class="btn-close" @click="closeForm">
                <i class="fa fa-times"></i>
            </button>
            <div class="modal-content animated slideInDown">
                <div class="row h-100 middle-xs" :style="bg">
                    <div class="col-xs-12 col-md-6 form-div">
                        <div class="form-content">
                            <h1 class="title">Envía esto a quien tú quieras</h1>
                            <form action="sendmails.php" method="POST" name="emailForm">
                                <input type="hidden" name="email_key" v-model="key_email">
                                <input type="email" name="email" v-model="email" required
                                       placeholder="Pon aquí su correo electrónico."
                                       pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
                                <button class="btn-primary" type="button" @click="register">
                                    <i class="fa fa-send"></i> Enviar
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "send-form-component",
        props: {
            key_email: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                email: '',
                bg: {
                    background: `white url("/imgs_send/img${this.key_email}.jpg") no-repeat`
                }
            }
        },
        methods: {
            closeForm() {
                this.$emit('closeForm')
            },
            register() {

                if (!this.$store.state.api_token) return;

                if (!document.forms.emailForm.checkValidity()) {

                    swal('Alerta', 'Ingresa tu correo electrónico', 'warning')

                    return
                }


                let page = '';

                switch (this.$route.path) {
                    case '/':
                        page = 'INICIO';
                        break;
                    case '/usar-el-cinturon':
                        page = 'USAR EL CINTURÓN';
                        this.key_email = 1;
                        break;
                    case '/respetar-las-reglas':
                        page = 'RESPETAR LAS REGLAS';
                        this.key_email = 2;
                        break;
                    case '/reducir-la-velocidad':
                        page = 'REDUCIR LA VELOCIDAD';
                        this.key_email = 3;
                        break;
                    case '/proteger-a-los-ninos':
                        page = 'PROTEGER A LOS NIÑOS';
                        this.key_email = 4;
                        break;
                    case '/prestar-atencion':
                        page = 'PRESTAR ATENCIÓN';
                        this.key_email = 5;
                        break;
                    case '/manejar-descansado':
                        page = 'MANEJAR DESCANSADO';
                        this.key_email = 6;
                        break;
                    case '/usar-casco':
                        page = 'USAR CASCO';
                        this.key_email = 7;
                        break;
                    case '/ser-cortes':
                        page = 'SER CORTÉS';
                        this.key_email = 8;
                        break;
                    case '/revisar-el-auto':
                        page = 'REVISAR EL AUTO';
                        this.key_email = 9;
                        break;
                    case '/consejos-adicionales':
                        page = 'CONSEJOS ADICIONALES';
                        break;
                    case '/certificado-gxsv':
                        page = 'CERTIFICADO GXSV';
                        this.key_email = 10;
                        break;
                }

                this.axios.post('newVisit', {
                    token: this.$store.state.api_token,
                    type: 'EMAIL',
                    name: page
                })
                    .then(res => {
                        document.forms.emailForm.submit()
                    })
                    .catch(console.error)
            }
        }
    };
</script>

<style lang="sass" scoped>
    .sendform-modal
        top: 0
        left: 0
        right: 0
        bottom: 0
        position: fixed
        z-index: 9999
        background-color: rgba(0, 0, 0, .6)
        .modal
            background-color: aliceblue
            position: fixed
            top: 50%
            left: 50%
            max-width: 90%
            max-height: 90%
            overflow-y: auto
            transform: translate(-50%, -50%)
            border-radius: 10px
            width: 65%
            height: 450px
            box-sizing: border-box
            @media only screen and (max-width: 64em)
                width: 90%
            .btn-close
                background-color: #ff3f46
                color: white
                position: absolute
                top: 5px
                right: 5px
                padding: 5px 9px
                border: none
                text-align: center
                border-radius: 3em
                font-size: 1.2em
                cursor: pointer
                z-index: 1
            .modal-content
                height: 100%
                width: 100%
                .row
                    padding: 25px 15px
                    box-sizing: border-box
                    background-position-x: 97%!important
                    background-size: 48% auto !important
                    background-position-y: center !important
                    @media only screen and (max-width: 64em)
                        background: none !important
                        text-align: center !important
        .title, .subtitle
            color: #747474

</style>
